module.exports = __webpack_public_path__ + "static/Grell-7b9ebd9f37abef3397a797ac9d579ce0.jpg";